export default "__VITE_ASSET__8d2baf9f__"